/* Jane Lushka 4.5: size guide dialog (replaces the Clean Size Charts app on the product page).
   Markup and data: snippets/jl-size-guide.liquid (part 'dialog' in sections/main-product.liquid; the "Size guide"
   links in snippets/product-variants.liquid and snippets/jl-pdp-sticky.liquid). Styles: assets/jl-size-guide.css.
   - Opens from any [data-jl-sg-open] (aria-controls names the dialog). A native modal <dialog> (showModal: the rest
     of the page is inert, top layer above the bag, the bar and chat); without showModal the [open] attribute and the
     same handlers. Focus goes to the title, Tab and Shift+Tab cycle inside, Escape, the close button and a click on
     the backdrop close it, focus returns to the link that opened it (or the size head link when that one is gone,
     e.g. the phone size sheet, which jl-sticky-atc.js closes first through data-jl-sheet-close).
   - Rows of the chosen size are highlighted (map value -> rows printed by the snippet: "XS/S" -> XS and S rows,
     "36" -> the EU 36 row); nothing is highlighted while no size is chosen.
   - cm / in: the shopper's choice is kept in localStorage (jl-size-unit); the default comes from the snippet
     (inches for the US and the UK). Storage failures are ignored.
   - Delegated listeners only, so a re-rendered section needs no init; no element, no error.
   Event: jl:size-guide-open { section, unit } on document (for GA4 if wanted). */
(function () {
  'use strict';

  if (window.__jlSizeGuideLoaded) return;
  window.__jlSizeGuideLoaded = true;

  var STORE_KEY = 'jl-size-unit';
  var current = null;
  var opener = null;

  function readUnit() {
    try {
      var v = window.localStorage.getItem(STORE_KEY);
      return v === 'cm' || v === 'in' ? v : null;
    } catch (e) {
      return null;
    }
  }

  function storeUnit(u) {
    try { window.localStorage.setItem(STORE_KEY, u); } catch (e) { /* private mode, blocked storage */ }
  }

  function cssEsc(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function visible(el) {
    return !!(el && document.documentElement.contains(el) && el.getClientRects().length && !el.closest('[inert]'));
  }

  function focusEl(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function setUnit(dlg, unit) {
    if (unit !== 'cm' && unit !== 'in') return;
    dlg.setAttribute('data-unit', unit);
    var btns = dlg.querySelectorAll('[data-jl-sg-unit]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-jl-sg-unit') === unit ? 'true' : 'false');
    }
  }

  function readMap(dlg) {
    if (dlg.__jlSgMap) return dlg.__jlSgMap;
    var map = {};
    var el = dlg.querySelector('script[data-jl-sg-map]');
    if (el) {
      try { map = JSON.parse(el.textContent || '{}') || {}; } catch (e) { map = {}; }
    }
    dlg.__jlSgMap = map;
    return map;
  }

  function pdpRoot(dlg) {
    var sid = dlg.getAttribute('data-section-id') || '';
    return (sid && document.querySelector('[data-jl-pdp][data-section-id="' + cssEsc(sid) + '"]')) ||
      dlg.closest('[data-jl-pdp]') || null;
  }

  function markRows(dlg) {
    var i;
    var old = dlg.querySelectorAll('tr.is-current');
    for (i = 0; i < old.length; i++) {
      old[i].classList.remove('is-current');
      old[i].removeAttribute('aria-current');
      var tag = old[i].querySelector('[data-jl-sg-tag]');
      if (tag) tag.parentNode.removeChild(tag);
    }
    var root = pdpRoot(dlg);
    var radio = root ? root.querySelector('[data-jl-size-fieldset] input[type="radio"]:checked') : null;
    if (!radio) return;
    var rows = readMap(dlg)[radio.value];
    if (!rows || !rows.length) return;
    var label = dlg.getAttribute('data-str-current') || '';
    for (i = 0; i < rows.length; i++) {
      var trs = dlg.querySelectorAll('tr[data-jl-sg-row="' + rows[i] + '"]');
      for (var j = 0; j < trs.length; j++) {
        trs[j].classList.add('is-current');
        trs[j].setAttribute('aria-current', 'true');
        var th = trs[j].querySelector('th');
        if (th && label) {
          var span = document.createElement('span');
          span.className = 'visually-hidden';
          span.setAttribute('data-jl-sg-tag', '');
          span.textContent = ' (' + label + ')';
          th.appendChild(span);
        }
      }
    }
  }

  function focusables(dlg) {
    var list = dlg.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < list.length; i++) if (list[i].getClientRects().length) out.push(list[i]);
    return out;
  }

  function open(dlg, from) {
    if (!dlg) return;
    if (current && current !== dlg) close(current, false);
    if (current === dlg) return;
    opener = from && visible(from) ? from : document.activeElement;
    setUnit(dlg, readUnit() || dlg.getAttribute('data-unit-default') || dlg.getAttribute('data-unit') || 'cm');
    markRows(dlg);
    if (typeof dlg.showModal === 'function') {
      if (!dlg.open) {
        try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
      }
    } else {
      dlg.setAttribute('open', '');
      dlg.classList.add('jl-sg--fallback');
    }
    current = dlg;
    document.documentElement.classList.add('jl-sg-lock');
    var body = dlg.querySelector('.jl-sg__body');
    if (body) body.scrollTop = 0;
    focusEl(dlg.querySelector('.jl-sg__title') || focusables(dlg)[0]);
    try {
      document.dispatchEvent(new CustomEvent('jl:size-guide-open', {
        detail: { section: dlg.getAttribute('data-section-id') || '', unit: dlg.getAttribute('data-unit') }
      }));
    } catch (e) { /* old browsers */ }
  }

  // cleanup only (the dialog is already closed, e.g. by the browser)
  function settle(dlg, restore) {
    if (current === dlg) current = null;
    document.documentElement.classList.remove('jl-sg-lock');
    var back = opener;
    opener = null;
    if (restore === false) return;
    if (!visible(back)) {
      var root = pdpRoot(dlg);
      back = root ? root.querySelector('.jl-size__head [data-jl-sg-open]') : null;
      if (!visible(back)) back = null;
    }
    if (back) focusEl(back);
  }

  function close(dlg, restore) {
    if (!dlg) return;
    dlg.__jlSgClosing = true;
    if (dlg.open && typeof dlg.close === 'function') {
      try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); }
    } else {
      dlg.removeAttribute('open');
    }
    dlg.__jlSgClosing = false;
    dlg.classList.remove('jl-sg--fallback');
    settle(dlg, restore);
  }

  function outside(dlg, e) {
    if (e.target !== dlg) return false;
    if (typeof e.clientX !== 'number' || (e.clientX === 0 && e.clientY === 0 && e.detail === 0)) return false;
    var r = dlg.getBoundingClientRect();
    return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var trigger = t.closest('[data-jl-sg-open]');
    if (trigger) {
      var id = trigger.getAttribute('aria-controls');
      var dlg = (id && document.getElementById(id)) || document.querySelector('[data-jl-sg]');
      if (!dlg || !dlg.matches('[data-jl-sg]')) return;
      e.preventDefault();
      open(dlg, trigger);
      return;
    }

    var inside = t.closest('[data-jl-sg]');
    if (!inside) return;
    if (t.closest('[data-jl-sg-close]')) {
      e.preventDefault();
      close(inside, true);
      return;
    }
    var unitBtn = t.closest('[data-jl-sg-unit]');
    if (unitBtn) {
      var unit = unitBtn.getAttribute('data-jl-sg-unit');
      setUnit(inside, unit);
      storeUnit(unit);
      return;
    }
    if (outside(inside, e)) close(inside, true);
  });

  document.addEventListener('keydown', function (e) {
    if (!current) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close(current, true);
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables(current);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0];
    var last = f[f.length - 1];
    var active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || !current.contains(active) || active === current.querySelector('.jl-sg__title')) {
        e.preventDefault();
        focusEl(last);
      }
    } else if (active === last || !current.contains(active)) {
      e.preventDefault();
      focusEl(first);
    }
  });

  // the browser closed it (Escape on some platforms, a form with method=dialog): clean up once
  document.addEventListener('cancel', function (e) {
    var dlg = e.target;
    if (!dlg || !dlg.matches || !dlg.matches('[data-jl-sg]')) return;
    e.preventDefault();
    close(dlg, true);
  }, true);
  document.addEventListener('close', function (e) {
    var dlg = e.target;
    if (!dlg || !dlg.matches || !dlg.matches('[data-jl-sg]') || dlg.__jlSgClosing) return;
    if (current === dlg) settle(dlg, true);
  }, true);

  // theme editor: a re-rendered section takes its open dialog with it
  document.addEventListener('shopify:section:unload', function () {
    if (current && !document.documentElement.contains(current)) {
      current = null;
      opener = null;
      document.documentElement.classList.remove('jl-sg-lock');
    }
  });
})();
